import { withStyles, Grid } from "@material-ui/core";
import React from "react";
const styles = (theme) => ({
  header: {
    fontSize: "10px",
    color: theme.dispatchPanelHeaderColor,
    lineHeight: "16px",
    fontWeight: 500,
    paddingTop: 8,
    paddingBottom: 8,
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    paddingLeft:20
  },
  error:{
    color: theme.errorBorderColor
  }
});

const Header = ({ classes, label, variant }) => {
  const variantClass = variant === "error" ? classes.error : ""
  return (
    <Grid item xs={12} className={`${classes.header} ${variantClass}`}>
      {label}
    </Grid>
  );
};

export default withStyles(styles)(Header);
